// Refresh existing candle graphics as well as their templates after a setting changes.
export function configureIndicatorColors(indicator) {
  if (!indicator.isType('HeikinAshi')) return { dispose() {} };
  const series = indicator.series;
  const original = series._applyGraphicsStates;
  const apply = function (item, previous) {
    const graphic = item.get('graphics');
    if (!graphic) return;
    original.call(this, item, previous);
    const open = item.get('openValueY'), close = item.get('valueY');
    if (graphic && Number.isFinite(open) && Number.isFinite(close)) {
      const color = indicator.get(close >= open ? 'increasingColor' : 'decreasingColor');
      if (color) graphic.setAll({ fill: color, stroke: color });
    }
  };
  series._applyGraphicsStates = apply;
  const refresh = () => {
    if (series.isDisposed()) return;
    series.dataItems.forEach((item, index) => apply.call(series, item, series.dataItems[Math.max(0, index - 1)]));
  };
  const listeners = ['increasingColor', 'decreasingColor'].map(key => indicator.on(key, refresh));
  refresh();
  let disposed = false;
  const owner = { dispose() {
    if (disposed) return;
    disposed = true;
    listeners.forEach(listener => listener.dispose());
    if (series._applyGraphicsStates === apply) series._applyGraphicsStates = original;
  } };
  indicator.addDisposer(owner);
  return owner;
}
